import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOnlineRuleTypes, getOnlineLog, getOnlineCompanyUpdateLogs, getBrandUpdateLogs } from '@/api/goodsCenter';
export default {
  name: 'onlineLoglist',
  data: function data() {
    return {
      dialogVisible: false,
      companyDialogVisible: false,
      logForm: {
        rule_id: '',
        rule_name: '',
        rule_type: '',
        operator_type: '',
        creator: '',
        updater_id: '',
        company_name: '',
        brand_name: '',
        s_created_time: '',
        e_created_time: '',
        s_updated_time: '',
        e_updated_time: '',
        selected_standard_ids: '',
        type: 'search',
        page: 1,
        pagesize: 50
      },
      searchForm1: {
        id: '',
        company_name: '',
        page: 1,
        pagesize: 5
      },
      totalCount1: null,
      // 日志列表
      totalCount2: null,
      // 更新前后日志
      totalCount3: null,
      // 变更所有日志
      dialogType: '',
      operator_type: '',
      //  操作类型 1:操作前 2:操作后 3:变更
      row: {},
      pages: {},
      create_time: '',
      update_time: '',
      ruleList: [],
      ruleTypes: [],
      operateList: [{
        name: '全部',
        id: ''
      }, {
        name: '添加',
        id: '3'
      }, {
        name: '修改',
        id: '4'
      }, {
        name: '删除',
        id: '5'
      }],
      logList1: [],
      logList2: [],
      brandProductLogList: [],
      // 自由兑信息
      companyLogList: [],
      zydPage: {
        page: 1,
        pagesize: 5
      },
      cityNewList: [],
      showCityDialog: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      filterText: ''
    };
  },
  computed: {
    sellUserList: function sellUserList() {
      return this.$store.state.user.sellUsersList;
    }
  },
  mounted: function mounted() {
    this.getRuleTypes();
    this.getOnlineRuleLog();
  },
  methods: {
    // 获取规则类型
    getRuleTypes: function getRuleTypes() {
      var _this = this;
      getOnlineRuleTypes().then(function (res) {
        _this.ruleTypes = res.data.data;
      });
    },
    // 查询规则列表
    searchLogList: function searchLogList() {
      this.logForm.page = 1;
      this.getOnlineRuleLog();
    },
    // 获取自由兑日志列表
    getOnlineRuleLog: function getOnlineRuleLog() {
      var _this2 = this;
      getOnlineLog(this.logForm).then(function (res) {
        _this2.ruleList = res.data.data.data;
        _this2.totalCount1 = res.data.data.totalCount;
      });
    },
    // 查询客户列表
    searchCompanyData: function searchCompanyData() {
      this.searchForm1.page = 1;
      this.getCompanyUpdateLogs(this.operator_type, this.row);
    },
    // 打开更新日志弹框
    openDialog: function openDialog(type, operator_type, row) {
      this.dialogType = type;
      this.operator_type = operator_type; // 更新前后 1 2
      this.row = row;
      if (type === 'brand') {
        this.dialogVisible = true;
        this.getBrandUpdateLog(operator_type, row);
      } else {
        this.companyDialogVisible = true;
        this.getCompanyUpdateLogs(this.operator_type, this.row);
      }
    },
    // 自由兑更新前后日志
    getBrandUpdateLog: function getBrandUpdateLog(operator_type, row) {
      var _this3 = this;
      var params = _objectSpread(_objectSpread({}, this.zydPage), {}, {
        log_id: row.id,
        operator_type: operator_type,
        rule_id: row.keyword_value,
        change_type: '' // 1为增加数据2减少
      });
      getBrandUpdateLogs(params).then(function (res) {
        _this3.brandProductLogList = res.data.data.data;
        // this.totalCount2 = res.data.data.totalCount
      });
    },
    // 更新前后客户日志列表
    getCompanyUpdateLogs: function getCompanyUpdateLogs(operator_type, row) {
      var _this4 = this;
      var params = _objectSpread(_objectSpread({}, this.searchForm1), {}, {
        log_id: row.id,
        operator_type: operator_type,
        rule_id: row.keyword_value,
        change_type: '' // 1为增加数据2减少
      });
      getOnlineCompanyUpdateLogs(params).then(function (res) {
        _this4.companyLogList = res.data.data.data;
        _this4.totalCount3 = res.data.data.totalCount;
      });
    },
    // 城市查看更多
    openCityDialog: function openCityDialog(citys) {
      this.cityNewList = citys;
      this.showCityDialog = true;
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    resetRuleForm: function resetRuleForm() {
      this.logForm = {
        rule_id: '',
        rule_name: '',
        rule_type: '',
        operator_type: '',
        creator: '',
        updater_id: '',
        company_name: '',
        brand_name: '',
        s_created_time: '',
        e_created_time: '',
        s_updated_time: '',
        e_updated_time: '',
        selected_standard_ids: '',
        type: 'search',
        page: 1,
        pagesize: 50
      };
      this.create_time = [];
    },
    // 分页操作
    onChange: function onChange(val, type) {
      // type 1 变更日志 2自由兑变更 3客户变更
      if (type === 1) {
        this.logForm.page = val;
        this.getOnlineRuleLog();
      } else if (type === 2) {
        this.zydPage.page = val;
        this.getZydUpdateLog(this.operator_type, this.row);
      } else if (type === 3) {
        this.searchForm1.page = val;
        this.getCompanyUpdateLogs(this.operator_type, this.row);
      }
    },
    handleSizeChange: function handleSizeChange(val, type) {
      if (type === 1) {
        this.logForm.pagesize = val;
        this.getOnlineRuleLog();
      } else if (type === 2) {
        this.zydPage.pagesize = val;
        this.getZydUpdateLog(this.operator_type, this.row);
      } else if (type === 3) {
        this.searchForm1.pagesize = val;
        this.getCompanyUpdateLogs(this.operator_type, this.row);
      }
    },
    // 搜索框时间处理
    changeTime: function changeTime(val, flag) {
      if (flag) {
        this.logForm.s_updated_time = val ? val[0] : '';
        this.logForm.e_updated_time = val ? val[1] : '';
      } else {
        this.logForm.s_created_time = val ? val[0] : '';
        this.logForm.e_created_time = val ? val[1] : '';
      }
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },
    closeDialogcompany: function closeDialogcompany() {
      this.companyDialogVisible = false;
      this.searchForm1 = {
        company_name: '',
        id: '',
        page: 1,
        pagesize: 5
      };
    }
  }
};